export default __webpack_public_path__ + "static/media/Ironclad Trinket of Eternal Resilience.febbb10a.jpg";